<template>
  <div>
    <ordersList v-if="this.hasAccess(&quot;PRIVILEGE_ORDER_LIST_MY&quot;) || this.hasAccess(&quot;PRIVILEGE_ORDER_LIST_ALL&quot;)" />
  </div>
</template>
<script>
import OrdersList from "../../order/list/OrdersList";
import {mapGetters} from "vuex";

export default {
  name: "Dashboard",
  components: {OrdersList},
  computed: {
    ...mapGetters('auth', ['hasAccess'])
  },

}
</script>
<style lang="scss" scoped>

</style>
